import React, { Fragment, useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import ActionBar from "../ActionBar"
import AutoComplete from "../AutoComplete"
import { Button, Hidden, Paper, IconButton, Menu } from "@material-ui/core"
import SearchIcon from "@material-ui/icons/Search"
import { toggleCreateUserDialog } from "../../actions/users"
import styles from "./styles"
import { hiddenLoginModal } from "../../actions/authentication"
import { toggleReferCrewDialog } from "../../actions/crew"
import { getCurrentHost } from "../../utils/getHost"
import ManageStripeDialog from "../ManageStripeDialog/index"
const parseQueryString = () => {
  const str = window.location.search
  const objURL = {}

  str.replace(new RegExp("([^?=&]+)(=([^&]*))?", "g"), ($0, $1, $2, $3) => {
    objURL[$1] = $3
  })
  return objURL
}

export default ({
  history,
  onChange,
  activeFilters = [],
  sortDescending = true,
  prop,
  ...props
}) => {
  // redux
  const authenticatedUser = useSelector(
    state => state.authentication.authenticatedUser
  )
  const accessLevel = useSelector(state => state.companies.accessLevel)
  const users = useSelector(state => state.misc.users)
  const [suggestions, setsuggestions] = useState([])
  const dispatch = useDispatch()
  //styles
  const thisClasses = styles()

  const [stripeOpenModel, setStripeOpenModel] = useState(false)

  // const parentRolesSuggestion =

  // Making it so that only Hollis has access
  // const stripeSuperAdmins = [52345, 90589, 166152]
  const stripeSuperAdmins = [166152]
  const currentUser =
    prop.hasOwnProperty("authentication") &&
    prop.authentication.authenticatedUser.id
  // menu stuff
  const [sortMenuAnchorEl, setsortMenuAnchorEl] = useState(null)
  const [searchMenuAnchorEl, setsearchMenuAnchorEl] = useState(null)
  const [filterMenuAnchorEl, setfilterMenuAnchorEl] = useState(null)
  const menuAnchorFunctions = {
    setsortMenuAnchorEl,
    setsearchMenuAnchorEl,
    setfilterMenuAnchorEl,
  }
  const handleOpenMenu = (e, name) => {
    menuAnchorFunctions[`set${name}MenuAnchorEl`](e.currentTarget)
  }
  const handleCloseMenu = name => {
    menuAnchorFunctions[`set${name}MenuAnchorEl`](null)
  }

  // autoComplete stuff
  const onAutoCompleteChange = (value, name) => {
    onChange({
      type: "AutoComplete",
      data: {
        name,
        value,
      },
    })
  }

  // sort menu stuff

  useEffect(
    () => {
      setsuggestions(users)
    },
    [users]
  )

  // refer crew member
  const handleReferCrewMember = () => {
    hiddenLoginModal()
      .then(res => {
        dispatch(toggleReferCrewDialog(true))
      })
      .catch(err => console.log({ err }))
  }

  useEffect(() => {
    const uri = window.location
    const clearUri = () => {
      const clean_uri = uri.toString().substring(0, uri.toString().indexOf("?"))
      window.history.replaceState({}, document.title, clean_uri)
    }
    if (uri.toString().search) {
      const params = parseQueryString()
      if (params.hasOwnProperty("openMenu")) {
        const buttonEl = document.getElementById(`${params.openMenu}-button`)
        if (
          buttonEl &&
          !menuAnchorFunctions[`${params.openMenu}MenuAnchorEl`]
        ) {
          setTimeout(() => {
            handleOpenMenu(
              {
                currentTarget: buttonEl,
              },
              params.openMenu
            )
            clearUri()
          }, 500)
        }
      }
      if (params.hasOwnProperty("openDialog")) {
        setTimeout(() => {
          switch (params.openDialog) {
            case "referCrewMember":
              handleReferCrewMember()
              clearUri()
              break
            default:
              return false
          }
        }, 500)
      }
    }
  })
  return (
    <ActionBar
      buttonChildren={classes => {
        return (
          <Fragment>
            {!authenticatedUser.id && (
              <Button
                onClick={() => {
                  localStorage.clear()
                  history.push("/login")
                }}
                color="primary"
                variant="contained"
                style={{ marginRight: "8px" }}
              >
                Login / Register
              </Button>
            )}

            {accessLevel === 1 && (
              <Hidden smDown>
                <Button
                  onClick={() => dispatch(toggleCreateUserDialog(true, {}))}
                  color="primary"
                  variant="contained"
                >
                  New Crew
                </Button>
              </Hidden>
            )}

            {stripeSuperAdmins.includes(currentUser) && (
              <Hidden smDown>
                <Button
                  onClick={() => setStripeOpenModel(true)}
                  color="primary"
                  variant="contained"
                  style={{ marginLeft: "20px", marginRight: "20px" }}
                >
                  Manage Crew Stripe
                </Button>
              </Hidden>
            )}

            <ManageStripeDialog
              open={stripeOpenModel}
              closeModel={() => setStripeOpenModel(false)}
            />

            {/* {prop.crew.crew.length >= 0 &&
              !prop.crew.loadingCrew && (
                <Hidden mdUp>
                  <Typography
                    variant="p"
                    style={{
                      paddingLeft: "10px",
                      fontSize: "1rem",
                      fontWeight: 600,
                    }}
                  >
                    {prop.crew.searchcrewLength} Crew
                  </Typography>
                </Hidden>
              )} */}
            {accessLevel !== 1 && (
              <React.Fragment>
                <Hidden smDown>
                  <Button
                    onClick={handleReferCrewMember}
                    color="primary"
                    variant="contained"
                  >
                    Refer Crew Member
                  </Button>
                </Hidden>
                <Hidden smUp>
                  <Button
                    onClick={handleReferCrewMember}
                    color="primary"
                    variant="contained"
                  >
                    Refer Crew
                  </Button>
                </Hidden>
              </React.Fragment>
            )}
          </Fragment>
        )
      }}
      sortChildren={classes => {
        return (
          <Fragment>
            <Hidden smDown>
              <div className={classes.searchWrapper}>
                <Paper
                  elevation={1}
                  className={
                    getCurrentHost() === "crewmama"
                      ? thisClasses.crewActionInput
                      : thisClasses.adeskActionInput
                  }
                >
                  <AutoComplete
                    // creatable
                    placeholder="Search Location"
                    className={thisClasses.searchOption}
                    InputClasses={{
                      underline: thisClasses.autoCompleteUnderline,
                    }}
                    caps
                    onChange={val => onAutoCompleteChange(val, "Location")}
                    // formatCreateLabel={value => `Search ${value}`}
                    labelKey="locations"
                    prop={prop}
                  />
                </Paper>
                <Paper
                  elevation={1}
                  className={
                    getCurrentHost() === "crewmama"
                      ? thisClasses.crewActionInput
                      : thisClasses.adeskActionInput
                  }
                >
                  <AutoComplete
                    placeholder="Search Name"
                    className={thisClasses.searchOption}
                    creatable
                    inputProps={
                      {
                        // menuIsOpen: !true
                      }
                    }
                    InputClasses={{
                      underline: thisClasses.autoCompleteUnderline,
                    }}
                    onChange={val => {
                      onAutoCompleteChange(val, "User")
                    }}
                    labelKey="full_name"
                    formatCreateLabel={value => `Search ${value}`}
                    prop={prop}
                  />
                </Paper>
                {/* <Paper elevation={1} style={{ marginRight: 16 }}>
                  <AutoComplete
                    // creatable
                    placeholder="Search Location"
                    InputClasses={{
                      underline: thisClasses.autoCompleteUnderline,
                    }}
                    caps
                    onChange={val => onAutoCompleteChange(val, "Location")}
                    // formatCreateLabel={value => `Search ${value}`}
                    labelKey="locations"
                    prop={prop}
                  />
                </Paper> */}
                {/* <Paper
                  elevation={1}
                  className={
                    getCurrentHost() === "crewmama"
                      ? thisClasses.crewActionInput
                      : thisClasses.adeskActionInput
                  }
                >
                  <AutoComplete
                    placeholder="Search Category"
                    className={thisClasses.searchOption}
                    InputClasses={{
                      underline: thisClasses.autoCompleteUnderline,
                    }}
                    caps
                    onChange={val => onAutoCompleteChange(val, "Category")}
                    labelKey="name"
                    prop={prop}
                  />
                </Paper> */}
                <Paper
                  elevation={1}
                  className={
                    getCurrentHost() === "crewmama"
                      ? thisClasses.crewActionInput
                      : thisClasses.adeskActionInput
                  }
                >
                  <AutoComplete
                    placeholder="Search Positions"
                    className={thisClasses.searchOption}
                    InputClasses={{
                      underline: thisClasses.autoCompleteUnderline,
                    }}
                    caps
                    onChange={val => onAutoCompleteChange(val, "Role")}
                    labelKey="name"
                    prop={prop}
                  />
                </Paper>
                <Paper
                  elevation={1}
                  className={
                    getCurrentHost() === "crewmama"
                      ? thisClasses.crewActionInput
                      : thisClasses.adeskActionInput
                  }
                >
                  <AutoComplete
                    placeholder="Search Equipment"
                    className={thisClasses.searchOption}
                    InputClasses={{
                      underline: thisClasses.autoCompleteUnderline,
                    }}
                    caps
                    onChange={val => onAutoCompleteChange(val, "Equipment")}
                    labelKey="name"
                    prop={{ ...prop, checkKey: "Equipment" }}
                  />
                </Paper>
              </div>
            </Hidden>
            <Hidden mdUp>
              <IconButton
                id="search-button"
                className={thisClasses.searchButton}
                onClick={e => handleOpenMenu(e, "search")}
              >
                <SearchIcon />
              </IconButton>
            </Hidden>
            <Menu
              anchorEl={searchMenuAnchorEl}
              open={Boolean(searchMenuAnchorEl)}
              onClose={() => handleCloseMenu("search")}
              getContentAnchorEl={null}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              classes={{ paper: thisClasses.searchMenuPaper }}
            >
              <Paper
                elevation={1}
                style={{ marginRight: 16 }}
                className={thisClasses.searchMenuItemPaper}
              >
                <AutoComplete
                  className={thisClasses.searchMenuAutoComplete}
                  placeholder="Search Name"
                  creatable
                  InputClasses={{
                    underline: thisClasses.autoCompleteUnderline,
                  }}
                  onChange={val => onAutoCompleteChange(val, "User")}
                  // suggestions={users}
                  labelKey="full_name"
                  formatCreateLabel={value => `Search ${value}`}
                  prop={prop}
                />
              </Paper>
              <Paper
                elevation={1}
                style={{ marginRight: 16 }}
                className={thisClasses.searchMenuItemPaper}
              >
                <AutoComplete
                  className={thisClasses.searchMenuAutoComplete}
                  placeholder="Search Location"
                  caps
                  InputClasses={{
                    underline: thisClasses.autoCompleteUnderline,
                  }}
                  onChange={val => onAutoCompleteChange(val, "Location")}
                  prop={prop}
                  labelKey="locations"
                />
              </Paper>
              {/* <Paper
                elevation={1}
                style={{ marginRight: 16 }}
                className={thisClasses.searchMenuItemPaper}
              >
                <AutoComplete
                  className={thisClasses.searchMenuAutoComplete}
                  placeholder="Search Category"
                  caps
                  InputClasses={{
                    underline: thisClasses.autoCompleteUnderline,
                  }}
                  onChange={val => onAutoCompleteChange(val, "Category")}
                  labelKey="name"
                  prop={prop}
                />
              </Paper> */}
              <Paper
                elevation={1}
                style={{ marginRight: 16 }}
                className={thisClasses.searchMenuItemPaper}
              >
                <AutoComplete
                  className={thisClasses.searchMenuAutoComplete}
                  placeholder="Search Positions"
                  caps
                  InputClasses={{
                    underline: thisClasses.autoCompleteUnderline,
                  }}
                  onChange={val => onAutoCompleteChange(val, "Role")}
                  labelKey="name"
                  prop={prop}
                />
              </Paper>
              <Paper elevation={1} className={thisClasses.searchMenuItemPaper}>
                <AutoComplete
                  className={thisClasses.searchMenuAutoComplete}
                  placeholder="Search Equipment"
                  caps
                  InputClasses={{
                    underline: thisClasses.autoCompleteUnderline,
                  }}
                  onChange={val => onAutoCompleteChange(val, "Equipment")}
                  labelKey="equip"
                  prop={prop}
                />
              </Paper>
            </Menu>
            {/* {!props.hideSort && (
              <Fragment>
                <div className={classes.filterSeperator} />
                <IconButton
                  id="sort-button"
                  className={thisClasses.sortButton}
                  onClick={e => handleOpenMenu(e, "sort")}
                >
                  <SortIcon />
                </IconButton>
              </Fragment>
            )}
            <Menu
              anchorEl={sortMenuAnchorEl}
              open={Boolean(sortMenuAnchorEl)}
              onClose={() => handleCloseMenu("sort")}
              getContentAnchorEl={null}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
            >
              <MenuItem onClick={() => handleSortMenuItemClicked("ranking")}>
                Ranking{" "}
                <ArrowIcon
                  className={classNames(thisClasses.arrowIcon, {
                    [thisClasses.arrowDown]:
                      activeSort === "ranking" && !sortDescending,
                    [thisClasses.arrowOut]: activeSort !== "ranking",
                  })}
                />
              </MenuItem>
              <MenuItem
                disabled={!selectedRole}
                onClick={() => handleSortMenuItemClicked("rate")}
              >
                Rate{" "}
                <ArrowIcon
                  className={classNames(thisClasses.arrowIcon, {
                    [thisClasses.arrowDown]:
                      activeSort === "rate" && !sortDescending,
                    [thisClasses.arrowOut]: activeSort !== "rate",
                  })}
                />
              </MenuItem>
            </Menu>
            <div className={classes.filterSeperator} /> */}
            {/* <IconButton
              id="filter-button"
              color={activeFilters.length > 0 ? "primary" : "default"}
              onClick={e => handleOpenMenu(e, "filter")}
            >
              <TuneIcon />
            </IconButton>
            <Menu
              anchorEl={filterMenuAnchorEl}
              open={Boolean(filterMenuAnchorEl)}
              onClose={() => handleCloseMenu("filter")}
              getContentAnchorEl={null}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              classes={{ paper: thisClasses.filterMenuPaper }}
            >
              <MenuItem
                className={thisClasses.filterMenuItem}
                onClick={() => handleFilterMenuItemClick("elite")}
              >
                Is Elite {activeFilters.indexOf("elite") > -1 && <CheckIcon />}
              </MenuItem>
              <MenuItem
                className={thisClasses.filterMenuItem}
                onClick={() => handleFilterMenuItemClick("labor_only")}
              >
                Labor Only{" "}
                {activeFilters.indexOf("labor_only") > -1 && <CheckIcon />}
              </MenuItem>
              <MenuItem
                className={thisClasses.filterMenuItem}
                onClick={() => handleFilterMenuItemClick("go_to_team")}
              >
                Go To Team{" "}
                {activeFilters.indexOf("go_to_team") > -1 && <CheckIcon />}
              </MenuItem>
            </Menu> */}
          </Fragment>
        )
      }}
    />
  )
}
